/*
 * @Author: hasee
 * @Date:   2016-12-12 18:22:00
 * @Last Modified by:   hasee
 * @Last Modified time: 2016-12-22 10:59:08
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);
import { GetQueryString, loadPageFail, getPlatform } from '../lib/units';

import show from './show'
import aNq from './answer_report'
import gift from './gift'
import activity from './activity'
import fragment from './fragment'
import ceshi from './ceshi'
import member from './member'
import toutiao_app from './toutiao_app' //头条小程序页面
import houseTreePeople from './houseTreePeople' // 房树人测试路由
import careerCard from './careerCard'
import datura from './datura' // 曼陀罗
import launch from './launch'
import matching from './matching'


const router = new VueRouter({
    routes: [{
            name: 'defalut',
            path: '/',
            redirect: '/index',
            meta: {
                title: '直接访问',
            }
        },
        show,
        ...aNq,
        ...gift,
        ...fragment,
        ...activity,
        ...ceshi,
        ...member,
        ...toutiao_app,
        ...houseTreePeople,
        ...careerCard,
        ...datura,
        ...launch,
        ...matching,
        {
            name: 'error',
            path: '/error',
            meta: {
                title: '错误-404页',
            },
            component: resolve => require(['../pages/errorPages/error.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '错误-404页',
                    err
                });
            })
        },
        {
            name: 'handleError',
            path: '*',
            redirect: '/error',
        }
    ]
});


router.addRoutes([{
    path: '/test',
    component: resolve => require(['../pages/test.vue'], resolve)
}]);

if (!IS_PRODUCTION) {
    router.addRoutes([{
        path: '/test_demo',
        component: resolve => require(['../pages/demoPages/index.vue'], resolve)
    }]);
    router.addRoutes([{
        path: '/test',
        component: resolve => require(['../pages/test.vue'], resolve)
    }]);
}

import store from '../store/store';

router.beforeEach((to, from, next) => {

    let token = to.query.cpToken || GetQueryString('cpToken');
    let channelId = to.query.channelId ? to.query.channelId : (GetQueryString('channelId') ? GetQueryString('channelId') : getPlatform.isWechat ? 1 : 513);
    //本地localStorage 存token 和 channelId
    if (token) {
        if (!localStorage.getItem('cp_token') || localStorage.getItem('cp_token') != token) {
            localStorage.setItem('cp_token', token)
        }
    }
    if (channelId) {
        if (!localStorage.getItem('cp_channelId') || localStorage.getItem('cp_channelId') != channelId) {
            localStorage.setItem('cp_channelId', channelId)
        }
    }

    if (!window.TRACKER.channelId) {
        if (channelId) {
            window.TRACKER.setChannelId(channelId);
            store.commit('setChannelId', channelId);

            let yxyid = to.query.yxyid ? to.query.yxyid : (GetQueryString('yxyid') ? GetQueryString('yxyid') : '');
            if (channelId && channelId == 1539 && yxyid) {
                store.commit('setYxyid', yxyid);
            }
        }
    }

    let tuiliyiKey = ''
    if (channelId == 2663) {
        // 推力益 标识符
        tuiliyiKey = to.query.key ? to.query.key : ''
        console.log(' --- 推力益 tuiliyiKey --- ', tuiliyiKey)
        if (tuiliyiKey) {
            store.commit('setTuiliyiKey', woNiuUnique);
            localStorage.setItem("tuiliyiKey", JSON.stringify(tuiliyiKey));
        }
    }

    // 唯爱妈妈小程序渠道
    if (+channelId === 3295) {
        if (to.query.sourceName) {
            localStorage.setItem("vimmSourceName", to.query.sourceName)
        }
    }

    let sourceName = to.query.sourceName ? to.query.sourceName : (GetQueryString('sourceName') ? GetQueryString('sourceName') : "");
    // 蜗牛睡眠标识符
    let woNiuUnique = to.query.unique ? to.query.unique : (GetQueryString('unique') ? GetQueryString('unique') : "")
    if (sourceName || woNiuUnique) {
        //添加异步操作全局跟踪标识，只需要请求不需要回调
        let source = sourceName ? sourceName : woNiuUnique
        store.dispatch('storeSource', { params: { 'sourceName': source } });
    }
    if (woNiuUnique) {
        store.commit('setWoNiuUnique', woNiuUnique);
        localStorage.setItem("woNiuUnique", JSON.stringify(woNiuUnique));
    }
    let sourceId = to.query.sourceId ? to.query.sourceId : (GetQueryString('sourceId') ? GetQueryString('sourceId') : "");
    if (sourceId) {
        store.commit('setSourceId', sourceId);
        sessionStorage.setItem("sourceId", JSON.stringify(sourceId));
    }
    if (to.query.auth_code || to.query.authCode) {
        sessionStorage.setItem("authCode", to.query.auth_code || to.query.authCode);
    }
    // 抑郁2选1版本特有逻辑，防止报告页点击后退时回到旧详情页detail
    const isYY_2_1_channels = [4619, 4618, 4690, 4691, 4692]
    if (isYY_2_1_channels.includes(+channelId)
        && to.path === '/detail/1147') {
        // 拦截抑郁2选1的旧详情页，指向新的详情页
        next({
            path: '/detail-yy/1147',
            query: to.query,
            params: to.params
        })
        return;
    }
    // isMBTI_2_1版本特有逻辑-end
    if (to.path === '/detail/1236') {
        // 拦截isMBTI_2_1的旧详情页，指向新的详情页
        next({
            path: '/detail-mbti/1236',
            query: to.query,
            params: to.params
        })
        return;
    }
    if (to.query.yxyid) {
        next();
        return;
    }
    if (from.query.yxyid) {
        let toQuery = JSON.parse(JSON.stringify(to.query));
        console.log(toQuery);
        toQuery.yxyid = from.query.yxyid;
        next({
            path: to.path,
            query: toQuery
        })
    } else {
        next();
    }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js